import React from "react";
import { FaTelegramPlane } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const JobCard = ({ logo, title, type, experience, bgColor }) => {
  const navigate = useNavigate();

  const handleApply = () => {
    navigate(`/apply?job=${encodeURIComponent(title)}`);
  };

  return (
    <div
      className="w-full sm:w-64 md:w-72 rounded-3xl text-center text-white p-6 shadow-lg relative overflow-hidden backdrop-blur-md border border-white/10 mx-auto"
      style={{ backgroundColor: bgColor }}
    >
      <img src={logo} alt={title} className="w-20 h-20 mx-auto mb-4" />
      <h3 className="text-xl font-semibold mb-2">{title}</h3>
      <p className="text-sm">{type}</p>
      <p className="text-sm mb-6">Experience: {experience}</p>

      <button
        className="flex items-center justify-center mx-auto border border-white px-5 py-2 rounded hover:bg-white hover:text-black transition"
        onClick={handleApply}
      >
        Apply <FaTelegramPlane className="ml-2" />
      </button>
    </div>
  );
};

export default JobCard;
